import { useEffect, useState } from "react";
import moment from "moment";
import { useDownload } from "../monthlyReport/MonthlyReportLayout/hooks";

import {
  TableDataRow,
  TableHeader
} from "components/organismos/GenericTable/GenericTable";
import { getStoreSalesReportData } from "api/storeSalesReport";

const useStoreSalesReportManagement = () => {
  const today = new Date();
  const dateFrom = new Date(today.getFullYear(), today.getMonth(), 1);
  const dateTo = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  const [headerRows, setHeaderRows] = useState<TableHeader>([]);
  const [dataRows, setDataRows] = useState<TableDataRow[]>([]);

  const [searchParams, setSearchParams] = useState<any>({});

  const searchFields: any[] = [
    {
      key: "targetDate",
      label: "対象期間",
      type: "dateRange",
      initialValue: { from: dateFrom, to: dateTo },
      row: 1,
      additionalProps: {
        dateFormat: "yyyy年MM月dd日"
      }
    },
    {
      key: "organization",
      label: "組織",
      type: "organization",
      initialValue: {
        orgCode: sessionStorage.getItem("loginUser.orgCode"),
        orgName: "全ての組織",
        categoryAry: undefined
      },
      row: 2,
      additionalProps: {
        functionType: 4,
        addAllItem: false,
        initOrgValue: String(searchParams.organization?.orgCode || "")
      }
    }
    // {
    //   key: "selectField",
    //   label: "業態",
    //   type: "select",
    //   initialValue: "value1",
    //   row: 3,
    //   additionalProps: {
    //     options: [
    //       { label: "値1", value: "value1" },
    //       { label: "値2", value: "value2" },
    //       { label: "値3", value: "value3" }
    //     ]
    //   }
    // }
  ];

  const targetStoresData = `対象店舗：${searchParams.organization?.orgName ||
    "全ての組織"}`;

  const targetPeriodData = `対象期間：${moment(
    searchParams.targetDate?.from || dateFrom
  ).format("YYYY/MM/DD")}~${moment(
    searchParams.targetDate?.to || dateTo
  ).format("YYYY/MM/DD")}`;

  const {
    downloadBudgetPerfomanceManagementCSV: downloadBudgetPerfomanceManagementCSV,
    downloadBudgetPerfomanceManagementExcel: downloadBudgetPerfomanceManagementExcel
  } = useDownload();

  const initialReportLayout = () => {
    // searchFieldsからinitialValueを持つ項目を抽出してsearchParamsを構築
    const searchParamsCaseAll = searchFields.reduce((params, field) => {
      if ("initialValue" in field) {
        params[field.key] = field.initialValue;
      }
      return params;
    }, {} as any);

    setSearchParams(searchParamsCaseAll);

    fetchBudgetPerformanceManagementMonthly();
  };

  const fetchBudgetPerformanceManagementMonthly = async () => {
    try {
      // APIパラメータを構築
      const params = {
        orgCode: searchParams.organization?.orgCode || "all",
        targetDateFrom: moment(
          searchParams.targetDate?.from || dateFrom
        ).format("YYYY/MM/DD"),
        targetDateTo: moment(searchParams.targetDate?.to || dateTo).format(
          "YYYY/MM/DD"
        ),
        layoutId: "9e072fb6-0c50-4443-9fdb-3c081ee769b9", // 固定値（URLから取得）
        loginStaffCode:
          sessionStorage.getItem("loginUser.staffCode") || "admin",
        functionType: 3, // 固定値（URLから取得）
        monthlyComparePrevYear: 0 // デフォルト値
      };

      const response = await getStoreSalesReportData(params);

      // レスポンスデータの構造に応じてheadersとdataを設定
      setHeaderRows(response.headers);
      setDataRows(response.data);
    } catch (error) {
      console.error("API error:", error);
    }
  };

  // 検索条件が変更されたときに呼ばれる関数
  const handleSearchChange = (params: any) => {
    console.log("検索条件が変更されました:", params);

    setSearchParams(params);
  };

  const handleDownloadCSV = (
    outputDataList: any[],
    headerInformation: any[][]
  ) => {
    const data = {
      footer: "",
      formName: "月次予実管理表",
      targetPeriod: targetPeriodData,
      targetStores: targetStoresData,
      headerInformation,
      searchResult: outputDataList,
      totalInformation: []
    };

    downloadBudgetPerfomanceManagementCSV(data, () => {});
  };

  const handleDownloadExcel = (
    outputDataList: any[],
    headerInformation: any[][],
    mergedRegions: number[][]
  ) => {
    const dataExcel = {
      formName: "店舗別売上管理帳票",
      targetPeriod: targetPeriodData,
      targetStores: targetStoresData,
      headerInformation: headerInformation,
      searchResult: outputDataList,
      totalInformation: [],
      mergedRegions: mergedRegions,
      codeColumnIndex: [0]
    };

    downloadBudgetPerfomanceManagementExcel(dataExcel, () => {});
  };

  useEffect(() => {
    initialReportLayout();
  }, []);

  return {
    headerRows,
    dataRows,
    searchFields,
    handleSearchChange,
    handleDownloadCSV,
    handleDownloadExcel,
    targetStoresData,
    targetPeriodData
  };
};

export default useStoreSalesReportManagement;
